import moment from 'moment';
import { LanguageService } from '../language-service/index.js';
import { fetchLanguageDeltas, interpolate, normalizeConfiguration } from './message-service-utils.js';
const defaultConfiguration = {
    languages: {},
};
class MessageService {
    constructor() {
        this.configuration = defaultConfiguration;
        this.data = {};
        this.dataCache = new Map();
        this.initialized = false;
        this.listeners = new Set();
        /**
         * Translates an expression into its corresponding text for the current language.
         */
        this.translate = (expression, args = {}) => {
            if (expression in this.data) {
                return interpolate(this.data[expression], args);
            }
            return interpolate(expression, args);
        };
    }
    /**
     * Initializes the message service. This can only be done once.
     */
    async initialize() {
        if (!LanguageService.hasBeenInitialized()) {
            throw new Error('[Message Service]: Trying to initialize MessageService before LanguageService');
        }
        if (this.initialized) {
            throw new Error('[Message service]: already initialized.');
        }
        // @ts-expect-error
        const { get } = await import('virtual:oswald-messages');
        const configuration = await get();
        this.initialized = true;
        this.configuration = normalizeConfiguration(configuration);
        void this.updateMessagesData(LanguageService.getCurrentLanguage());
        LanguageService.addListener((language) => {
            void this.updateMessagesData(language);
        });
    }
    hasBeenInitialized() {
        return this.initialized;
    }
    /**
     * This method adds a new listener that will be used called everytime that the language changes.
     *
     * @param listener - The listener to be added.
     */
    addListener(listener) {
        if (this.listeners.has(listener)) {
            throw Error('[Message Service]: This listener was already added.');
        }
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    /**
     * Notify all of the service listeners.
     */
    notify() {
        this.listeners.forEach((listener) => listener());
    }
    async updateMessagesData(language) {
        if (this.dataCache.has(language)) {
            moment.locale(language);
            this.data = this.dataCache.get(language) ?? {};
            this.notify();
            return;
        }
        const languages = this.configuration.languages;
        const deltas = await fetchLanguageDeltas(languages, language);
        const data = deltas.reduce((accumulator, delta) => {
            return {
                ...accumulator,
                ...delta.data,
            };
        }, {});
        moment.locale(language);
        this.data = data;
        this.dataCache.set(language, data);
        this.notify();
    }
}
const instance = new MessageService();
export { fetchLanguageDeltas, instance as MessageService, };
//# sourceMappingURL=message-service.js.map